import { DateFormatter } from './DateFormatter';
import { useMemo } from 'react';

const LOCALE = 'en-US';

export function useDateFormatter(locale = LOCALE) {
  const dateFormatter = useMemo(() => new DateFormatter(locale), [locale]);
  return dateFormatter;
}
